/**
 * 플레어 복사열·높이 계산용 데이터 로더.
 *
 * 원본: /data/api521-flare-radiation.json (API 521 7판 Annex F.2 "단순법").
 * Table F.1(F-factor)·Table 12(허용 방사강도)는 텍스트/표라 페이지 이미지로
 * 정확히 확인했고, 화염길이·바람틸트는 공개된 플레어 사이징 스프레드시트의
 * 커브핏 회귀식(원 출처는 API 521 Figure 7·9)을 그대로 옮겼다 —
 * `data/verify-api521-flare-radiation.py`가 API 521 Annex C.2.2 예제로
 * 전체 절차를 검증한다.
 */
import raw from "../../data/api521-flare-radiation.json";

export interface FFactorPoint {
  readonly burnerDiameterCm: number;
  readonly fractionHeatRadiated: number;
}

export type FFactorGas = "hydrogen" | "butane" | "methaneNaturalGas";

export const F_FACTOR_TABLE: Readonly<Record<FFactorGas, readonly FFactorPoint[]>> = {
  hydrogen: raw.fFactorTable.hydrogen,
  butane: raw.fFactorTable.butane,
  methaneNaturalGas: raw.fFactorTable.methaneNaturalGas,
};

export const F_FACTOR_GAS_LABELS: Record<FFactorGas, string> = {
  hydrogen: "수소",
  butane: "부탄(중질 탄화수소류 대표)",
  methaneNaturalGas: "메탄·천연가스(95% CH4)",
};

export interface AllowableRadiationLevel {
  readonly kwM2: number;
  readonly conditionKo: string;
}

export const ALLOWABLE_RADIATION_LEVELS: readonly AllowableRadiationLevel[] =
  raw.allowableRadiationTable.levels;

export const FLAME_LENGTH_CORRELATION = raw.flameLengthCorrelation;

export interface RationalCurveCoefficients {
  readonly a0: number;
  readonly a1: number;
  readonly b1: number;
  readonly b2: number;
}

export const WIND_TILT_CORRELATION: {
  readonly dxOverL: RationalCurveCoefficients;
  readonly dyOverL: RationalCurveCoefficients;
  readonly validXMax: number;
} = raw.windTiltCorrelation;
